import { useState } from 'react';
import { NOTIFICATION_DURATION, NotificationState } from '../../types/videocall.types';

export const useNotification = (initialState: NotificationState) => {
  const [notification, setNotification] = useState<NotificationState>(initialState);

  const showNotification = (message: string, severity: NotificationState['severity']) => {
    setNotification({ isOpen: true, message, severity });
    setTimeout(() => {
      setNotification(prev => ({ ...prev, isOpen: false }));
    }, NOTIFICATION_DURATION);
  };

  return { notification, showNotification };
};

export default useNotification;